import {
  Alert,
  LinearProgress,
  Stack,
} from '@mui/material';
import React from 'react';
import PatientCard from './PatientCard/PatientCard';
import useFocusOnLastSelectedPatient from '../hooks/useFocusOnLastSelectedPatient';

const PatientCardList = ({ patientList, noData_label }) => {
  const lastCardRef =
    useFocusOnLastSelectedPatient(patientList);

  return (
    <React.Fragment>
      {
        <Stack>
          <br />
          {!patientList ? (
            <></>
          ) : patientList.length === 0 ? (
            <Alert
              severity="warning"
              sx={{
                display: 'flex',
                justifyContent: 'center',
              }}
            >
              {noData_label}
            </Alert>
          ) : patientList === 'loading' ? (
            <LinearProgress />
          ) : (
            <Stack gap=".5em">
              {patientList.map((el) => (
                <PatientCard
                  key={el.FldId}
                  Patient={el}
                  ref={lastCardRef}
                />
              ))}
            </Stack>
          )}
        </Stack>
      }
    </React.Fragment>
  );
};

export default PatientCardList;
